import { useElementBounding } from '@vueuse/core'
import { acceptHMRUpdate, defineStore } from 'pinia'
import type { QFooter } from 'quasar'
import { computed, reactive, ref, shallowRef } from 'vue'

import configTheme from '@/config/theme.json'

export const useThemeStore = defineStore('theme', () => {
  const pageOffsetTop = ref(0)

  const elBreadcrumbs = shallowRef<HTMLDivElement | null>(null)
  const elBreadcrumbsBounding = reactive(useElementBounding(elBreadcrumbs))
  const elBreadcrumbsBoundingHeight = computed<number>(
    () => elBreadcrumbsBounding.height,
  )
  const elPageSearchList = shallowRef<HTMLDivElement | null>(null)
  const elQFooter = shallowRef<InstanceType<typeof QFooter> | null>(null)
  const elQFooterBounding = reactive(useElementBounding(elQFooter))
  const elQFooterBoundingHeight = computed(
    () => `${elQFooterBounding.height}px`,
  )
  const elListingItemFavoritesBtnBoundingsWidth = ref(0)

  const pageStyleFn = (offset: number) => {
    pageOffsetTop.value = offset

    if (process.env.CLIENT) {
      document.body.style.setProperty('--q-page-offset-top', `${offset}px`)
    }

    return {
      height: offset ? `calc(100dvh - ${offset}px)` : '100dvh',
    }
  }

  const layoutDrawer = ref<boolean>(false)
  const layoutOverlayLocal = ref<boolean>(false)

  const layoutOverlay = computed({
    get: () => layoutOverlayLocal.value,
    set: (v) => {
      const appNavBarLayoutOverlay =
        configTheme.components.AppNavBar.layoutOverlay

      layoutOverlayLocal.value = appNavBarLayoutOverlay ? v : false
    },
  })

  return {
    elBreadcrumbs,
    elBreadcrumbsBounding,
    elBreadcrumbsBoundingHeight,

    elListingItemFavoritesBtnBoundingsWidth,

    elPageSearchList,
    elQFooter,
    elQFooterBounding,
    elQFooterBoundingHeight,

    layoutDrawer,
    layoutOverlay,
    pageOffsetTop,
    pageStyleFn,
  }
})

if (import.meta.hot && process.env.NODE_ENV === 'development') {
  import.meta.hot.accept(acceptHMRUpdate(useThemeStore, import.meta.hot))
}
